export const FRAMES_PAGE_URL = '/frames';
export const HEALTH_PAGE_URL = '/health';
export const SEARCH_PAGE_URL = '/search';
export const LAST_24_HOUR_QUERY_PARAMS = '?from=now-24h&to=now';
export const NUMBER_OF_FILTERS = 6;
export const DEFAULT_STATUS_INDICATOR_SIZE = '8px';
export const FRAMES_TABLE_PAGE_SIZE = 10;
export const SEARCH_RESULTS_LIMIT = 5;
export const DEFAULT_TIME_ZONE = 'Europe/London';
export const DEMAND_RATE = 'Demand Rate';
export const DELIVERY_RATE = 'Delivery Rate';
